import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=67f5817e&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=67f5817e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5817e",
  null
  
)

export default component.exports